<template>
    <div id="resources-menu">
        <div class="container-wrapper">
            <div class="m-b-12 resource-desktop">
                <span class="font text-base f-w-500 l-h-20 l-t-s-3 text-color tertiary m-b-12">Resources</span>
            </div>
            <div v-for="(menu, i) in subMenus" :key="i" class="menu-container">
                <!-- <nuxt-link :to="menu.uri" target="_blank"> -->
                <div :id="menu.identifier" class="item" @click="handleNavigate(menu)">
                    <div class="flex items-center justify-start item-inner">
                        <span class="font-bold font-manrope">{{ menu.name }}</span>
                        <UIcon name="i-pkg-navigation-arrow-right" class="size-5 chevron-icon" />
                    </div>
                </div>
                <!-- </nuxt-link> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavStyle3',
    props: {
        subMenus: {
            type: Array,
            default: () => ([]),
        },
    },
    methods: {
        handleNavigate(menu) {
            if (!import.meta.client) return;
            
            document.body.style.overflow = 'scroll';
            if (menu.uri.startsWith('/')) {
                this.$router.push(menu.uri);
                return;
            }
            window.location.href = menu.uri;
        },
    },
};
</script>

<style lang="scss" scoped>
.container-wrapper{
    min-width: 356px;
    width: 100%;
    padding: 0 20px;
    .resource-desktop{
            display: none;
        }
    .menu-container {
        &:last-child {
        border-bottom: none;
        }
    width: 100%;
    border-bottom: 2px solid #F4F4F4;
    padding: 20px 0;
        .item {

                .item-inner {
                    cursor: pointer;
                    gap: 4px;
                    min-height: 30px;
                    
                    .chevron-icon {
                        opacity: 0;
                        transition: opacity 0.2s ease-in-out;
                    }
                    
                    &:hover .chevron-icon {
                        opacity: 1;
                    }
                }
    }
}
}

@media screen and (min-width: 992px) {
    #resources-menu{
        display: flex;
        max-height: 478px
    }
    .container-wrapper{
        width: 260px;
        min-width: unset;
        padding: 10px 32px;

        .resource-desktop{
            display: block;
        }
        .menu-container{
            display: flex;
            border-bottom: unset;
            padding: 10px 0;
            max-width: 236px;
                .item-inner {
                    border-radius: 12px;
                    
                    &:hover {
                        text-decoration: underline !important;
                    }
                    
                    .chevron-icon {
                        opacity: 0;
                        transition: opacity 0.2s ease-in-out;
                    }
                    
                    &:hover .chevron-icon {
                        opacity: 1;
                    }
                }
        }
    }
}
</style>
